import { useTranslation } from "react-i18next";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
import { SchoolSafetyLeftMenuList } from "../utils/constants";
import { CommonPageUiLayer } from "../components/CommonPageUiLayer";

export const UiStructure = ({ title, fileStoreId, label }) => {
  const { t } = useTranslation();
  return (
    <CommonPageUiLayer leftNavsList={SchoolSafetyLeftMenuList}>
      <div className="container">
        <div className="row">
          <div className="inner-title2">
            <h3 className="fontSizeClass">{t(title)}</h3>
          </div>
          <div className="col-lg-12 about-head1">
            <div className="d-flex align-items-center mt-3">
              <i className="bi bi-file-earmark-arrow-down"></i>
              <DownloadFileByFileStoreId
                fileStoreId={fileStoreId}
                label={label}
              />
            </div>
            <a
              className="nav-link fontSizeClass text-center mt-5"
              href="https://get.adobe.com/reader/"
              target="_blank"
              rel="noreferrer"
            >
              {t("Click here to download the Free Acrobat Reader")}
            </a>
          </div>
        </div>
      </div>
    </CommonPageUiLayer>
  );
};

const Form_For_Inventory = () => (
  <UiStructure
    title="Form for Inventory of School for DM"
    fileStoreId="3ac9c309-0e53-464f-940f-0a9f28b3412c"
    label="Form for Inventory of School for DM"
  />
);

export default Form_For_Inventory;
